import { Link as RouterLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useUserStore, useUtilityStore } from 'src/stores/useMobxStores';
import { Panel, PanelType } from '@fluentui/react';
import { ButtonContainer, Divider, DrawerContainer, Logo, NavBox } from '../Navbar/styledComponents';
import { FlexContainer } from 'src/components/base/container';
import { List } from 'src/components/base/list';
import {  HiddenTabletUp } from 'src/components/base/hidden';
import NavAds from '../Ads/NavAds';
import { NavbarItem } from '../Navbar/NavItems/NavbarItem';
import { NAV_ITEMS } from 'src/constants/NavConstants/NavBarConstants';
import { AuthBarItem } from '../Navbar/NavItems/AuthBarItem';
import { SignInItem } from '../Navbar/NavItems/SignInItem';
import logo from '../../../assets/images/DLMS-Logo-Vector-2021-250x80.png';
import { CloseButton, Drawer } from './styledComponents';




const DrawerModal = () => {
  const utilityStore = useUtilityStore();
  const userStore = useUserStore();
  const panelStyles = {
    header: {display: 'none'}, content: {padding: '0px', margin: '0px'}, commands: { display: 'none'}
  };
  const content = (
    <DrawerContainer>
      <FlexContainer justifyContent='center'>
        <RouterLink to='/'>
          <Logo onClick={utilityStore.closeDrawer} src={logo} alt='logo' />
        </RouterLink>
      </FlexContainer>
      <Divider />
      <NavBox>
        <List>
          {NAV_ITEMS.map((item, itemIndex) => {
            if (item.hideAnonymous && !userStore.IsAuthenticated) {
              return null;
            }
            if (item.hideLoggedIn && userStore.IsAuthenticated) {
              return null;
            }
            if (item.requireLogin) {
              return userStore.IsAuthenticated ? (
                <NavbarItem key={itemIndex} handleNavbarClose={utilityStore.closeDrawer} item={item} />
              ) : (
                <AuthBarItem key={itemIndex} handleNavbarClose={utilityStore.closeDrawer} item={item} />
              );
            }

            return item.hideDesktop ? (
              <HiddenTabletUp key={itemIndex}>
                <SignInItem handleNavbarClose={utilityStore.closeDrawer} item={item} />
              </HiddenTabletUp>
            ) : (
              <NavbarItem key={itemIndex} handleNavbarClose={utilityStore.closeDrawer} item={item} />
            );
          })}
        </List>
        <FlexContainer gap='10px' column justifyContent='flex-start'>
          <NavAds position={2} />
          <NavAds position={3} />
          <NavAds position={4} />
        </FlexContainer>
        <ButtonContainer>
          <CloseButton onClick={utilityStore.closeDrawer}>Close</CloseButton>
        </ButtonContainer>
      </NavBox>
    </DrawerContainer>
  );

  return (
    <Panel
      headerText='Sample panel'
      isOpen={utilityStore.drawer}
      onDismiss={utilityStore.closeDrawer}
      isLightDismiss={true}
      hasCloseButton={false}
      styles={panelStyles}
      isBlocking={true}
      type={PanelType.customNear}
      customWidth={'256px'}
      focusTrapZoneProps={{disableFirstFocus: true}}
      // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
    >
      <Drawer>{content}</Drawer>
    </Panel>
  );
};

export default observer(DrawerModal);
